<template>
  <div class="suggest py-10 px30 text-center">
    <span class="text-grey-2 text-16 pt-4 pb-3" v-html="title"> </span>

    <div class="input-box mt-4 mb-7 relative">
      <input
        class="address-input rounded-md text-16 w-full"
        ref="address"
        :placeholder="placeholder"
        @input="setDefault"
        @blur="validateField"
        v-model="values.name"
      />
      <div class="mt-1">
        <span class="block text-12 text-red-500" v-if="isError">
          Please put a valid address
        </span>
      </div>
    </div>
    <div class="mb-10">
      <button
        type="button"
        class="text-16 px-17 py-5 rounded-28 shadow-primary"
        :class="btnActiveClass"
        :disabled="!isActive"
        @click="createBusineesOrCharity"
      >
        Request
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isPartner: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.initMap();
  },
  data() {
    return {
      autocomplete: null,
      values: {
        address: null,
        lat: null,
        lng: null
      },
      check: false
    };
  },
  computed: {
    isActive() {
      return this.values.address && this.values.lat && this.values.lng;
    },
    isError() {
      return (
        this.check && this.values.name && !this.values.lat && !this.values.lng
      );
    },
    btnActiveClass() {
      return {
        "bg-white text-grey-3": !this.isActive,
        "bg-btn-bg text-white": this.isActive
      };
    },
    title() {
      return this.isPartner
        ? "Don't see what you're looking for ?"
        : "Is there someone else you want to <br /> support ?";
    },
    placeholder() {
      return this.isPartner ? "Enter Business Name" : "Enter a Charity Name";
    },
    endpoint() {
      return this.isPartner ? "business_create" : "charity_create";
    }
  },
  methods: {
    initMap() {
      const input = this.$refs.address;
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ["name", "formatted_address", "geometry"]
      });
      google.maps.event.addListener(this.autocomplete, "place_changed", () => {
        let place = {
          ...this.autocomplete.getPlace()
        };
        this.extractAddress(place);
      });
    },
    extractAddress(place) {
      this.values.name = place.name;
      this.values.address = place.formatted_address;
      this.values.lat = place.lat || place.geometry.location.lat();
      this.values.lng = place.lng || place.geometry.location.lng();
      this.check = false;
    },
    setDefault() {
      this.check = false;
      this.values.address = null;
      this.values.lng = null;
      this.values.lat = null;
      this.values.lng = null;
    },
    validateField() {
      setTimeout(() => {
        this.check = true;
      }, 500);
    },
    async createBusineesOrCharity() {
      const res = await this.$http.post(`user/${this.endpoint}`, this.values);
      if (!res.status) return;
      this.values = {
        address: null,
        name: null,
        lat: null,
        lng: null
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.suggest {
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
  z-index: 10;
  box-shadow: 0px 20px 20px 40px #0000001a;
  background-color: white;
  margin: 0 -30px;
  .input-box {
  .address-input {
    background-color: rgba(32, 32, 48, 0.05);
    transition: border-color 0.2s ease;
    resize: none;
    padding: 10px 0 10px 60px;
    height: 56px;
  }
  .address-input::placeholder {
    color: rgba(0, 0, 0, 0.3);
    width: 100%;
    padding-top: 18px;
    font-size: 16px;
  }
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    background-image: url("/img/pwa/search.svg");
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    top: 20px;
    left: 26px;
  }
}
}
</style>
